import { FahrradWert, Produktlinienname } from '@ps20/bff-models';

export const ZUSATZOPTION_FAHRRAD_ID = 'diebstahlVonFahrradUndFortbewegungsmitteln';

export interface FahradwertForLinie {
  produktlinie: Produktlinienname;
  summe: FahrradWert;
}
